export default __webpack_public_path__ + "f34ec26e3aeee9530de11d56560ffb6f.png";